/* =====================================================================
   CUSTOM: Look builder — "Krijo look-un tënd".
   ---------------------------------------------------------------------
   One photo plus one button. Each press advances to the next stage
   (bare lashes -> one coat -> full volume -> remove) and swaps the photo,
   the label, the optional description and the button's own label. The
   last stage wraps back to the first, so the demo can run forever.

   Stage data is rendered as a JSON script tag by sections/look-builder.liquid.
   No-JS: the first stage stays on screen and the button is hidden by CSS.
   ===================================================================== */
class LookBuilder extends HTMLElement {
  connectedCallback() {
    const data = this.querySelector('.look-builder__data');
    if (!data) return;

    try {
      this.stages = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(this.stages) || this.stages.length < 2) return;

    this.frames = this.querySelectorAll('.look-builder__frame');
    this.label = this.querySelector('.look-builder__label-text');
    this.heart = this.querySelector('.look-builder__heart');
    this.desc = this.querySelector('.look-builder__desc');
    this.button = this.querySelector('.look-builder__btn');
    if (!this.button) return;

    this.classList.add('look-builder--ready');
    // Mark stage 1 active up front: the "ready" CSS hides any frame that isn't.
    this.show(0);
    this.button.addEventListener('click', () => {
      this.show((this.index + 1) % this.stages.length);
    });
  }

  show(index) {
    const stage = this.stages[index];
    this.index = index;

    this.frames.forEach((frame, i) => {
      frame.classList.toggle('is-active', i === index);
      frame.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    if (this.label) this.label.textContent = stage.label || '';
    if (this.heart) this.heart.classList.toggle('is-filled', stage.heart === true);
    if (this.desc) this.desc.innerHTML = stage.description || '';
    this.button.textContent = stage.button || '';
  }
}

if (!customElements.get('look-builder')) {
  customElements.define('look-builder', LookBuilder);
}
